/// <reference path="../types/index.d.ts" />

import '../client_forms/culinaryteam4/style.css';
import FormStructure from './culinaryteam4/form_structure';

export default FormStructure;